import type { BoardState } from '@draughts/shared';

/**
 * Serializza la posizione in una stringa confrontabile.
 *
 * Include il TURNO: la stessa disposizione con il tratto all'altro non è la
 * stessa posizione, e la regola della ripetizione lo pretende.
 *
 * Vive in un modulo suo, e non più dentro `move-execution`, perché lo usano
 * anche i due COSTRUTTORI di posizione (`createInitialBoard`, `fenToBoardState`)
 * per seminare `positionHistory` con la posizione di partenza — e
 * `move-execution` importa da `board-utils`, quindi l'import inverso sarebbe un
 * ciclo. `move-execution` la ri-esporta, così chi la importava da lì non cambia
 * una riga.
 */
export function serializePosition(board: BoardState): string {
  // Ordina i pezzi per avere una rappresentazione consistente
  const sortedPieces = [...board.pieces].sort((a, b) => {
    if (a.square !== b.square) return a.square - b.square;
    if (a.color !== b.color) return a.color.localeCompare(b.color);
    return a.type.localeCompare(b.type);
  });

  // Crea una stringa rappresentativa includendo il turno
  const piecesStr = sortedPieces
    .map((p) => `${p.color[0]}${p.type[0]}${p.square}`)
    .join('|');

  return `${board.currentTurn}:${piecesStr}`;
}
